export const MENU_ITEMS = {
  ADMIN: {
    label: "Admin",
    children: {
      // Quality check lives here rather than on the primary nav: that nav is
      // 60vw with fixed-width siblings, so a seventh top-level item fell into
      // antd's "…" overflow for the roles that use this page most.
      QUALITY_CHECK: "/quality-check",
      STANDOUT_REVIEW: "/standout-review",
      PROJECTS: "/projects",
      CURRICULUM_PLANS: "/curriculum-plans",
      USERS: "/users",
      SETTINGS: "/settings",
    },
  },
  EVALUATIONS: "/evaluations",
  CLASSES: "/classes",
  STUDENTS: "/students",
  TRYOUTS: "/tryouts",
  MAKEUPS: "/makeups",
} as const

export const MENU_VIEW_ITEMS = {
  FRONT_DESK_VIEW: "/front-desk",
  TEACHER_VIEW: "/teacher",
  // SUPER_VIEW: "/super-view",
} as const

export const USER_MENU_ITEMS = {
  PROFILE: "/profile",
  SETTINGS: "/settings",
  AUTH_TEST: "/auth-test",
  TEST: "/test",
  LOGOUT: "/login", // Clicking the link logs them out, so we redirect to login
} as const
